import { render } from "./ActorEditing.vue?vue&type=template&id=dbb6f120"
import script from "./ActorEditing.vue?vue&type=script&lang=js"
export * from "./ActorEditing.vue?vue&type=script&lang=js"
script.render = render

export default script